module.exports = __webpack_public_path__ + "static/media/arrow-bottom.58fcfee3.svg";